export const REQUEST_FOR_ELECTRONIC_CONSENT = 'REQUEST_FOR_ELECTRONIC_CONSENT';
export const ELECTRONIC_CONSENT_SUCCESS = 'ELECTRONIC_CONSENT_SUCCESS';
export const ELECTRONIC_CONSENT_ERROR = 'ELECTRONIC_CONSENT_ERROR';
export const REQUEST_FOR_ELECTRONIC_CONSENT_MEMBER =
  'REQUEST_FOR_ELECTRONIC_CONSENT_MEMBER';
export const ELECTRONIC_CONSENT_MEMBER_SUCCESS =
  'ELECTRONIC_CONSENT_MEMBER_SUCCESS';
export const ELECTRONIC_CONSENT_MEMBER_ERROR =
  'ELECTRONIC_CONSENT_MEMBER_ERROR';
